<template>
  <div class="pact-body">
    <div v-for="item in list" :key="item.id">
      <div class="pact-list-line"></div>
      <div class="header">
        <span class="left" @click="preview(item)">预览</span>
        <span class="right" @click="sendMail(item)"
          >发送邮箱(<span>默认offer邮箱</span>)</span
        >
      </div>
      <div class="pact" @click="preview(item)">
        <img src="https://web-data.zmlearn.com/image/rgemSGc8FuAwYc1n6BraDz/pdf.png" alt="" srcset="" />
      </div>
    </div>
    <div class="no-pact" v-if="isNull">
      <div>
        <img src="https://web-data.zmlearn.com/image/kED1eTLQU5Z2mBDFeRKgU7/no_arrange.png" alt="" srcset="" />
        <div>您还没有电子合同</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
import * as dd from 'dingtalk-jsapi';
import { myContract, eContractPreview } from '../../api/pact';

Vue.use(Toast);

export default {
  data() {
    return {
      platform: '',
      mail: '',
      list: [],
      isNull: false,
    };
  },
  mounted() {
    this.init();
    this.platform = dd.env.platform;
  },
  methods: {
    async init() {
      const res = await myContract();
      if (res) {
        this.mail = res.email;
        this.list = res.record;
        if (res.record.length == 0) this.isNull = true;
      } else {
        this.isNull = true;
      }
    },

    preview(val) {
      eContractPreview({ recordId: val.id })
        .then((res) => {
          if (res) {
            if (!res.pageUrl) return Toast.fail('您还没有电子合同');
            if (
              !res.pageUrl
                .substring(res.pageUrl.length - 4, res.pageUrl.length)
                .includes('pdf')
            ) return (window.location.href = res.pageUrl);
            if (this.platform === 'ios') {
              window.location.href = res.pageUrl;
            } else {
              this.$router.push({
                path: '/pact/pdf',
                query: {
                  pdfurl: res.pageUrl,
                },
              });
            }
          }
        })
        .catch((err) => {
          return Toast.fail(err.message);
        });
    },

    sendMail(val) {
      this.$router.push({
        path: '/pact/mail',
        query: {
          mail: this.mail,
          recordId: val.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.pact-body {
  font-size: 30px;
  > div {
    .header {
      height: 80px;
      line-height: 86px;
      border-bottom: 1px solid #ebebeb;
      .left {
        color: #0066ff;
        padding-left: 40px;
      }
      .right {
        color: #0066ff;
        margin-left: 40px;
        span {
          font-size: 26px;
          padding: 0 5px;
        }
      }
    }
    .pact {
      background: #ebebeb;
      margin: 30px 40px;
      width: 300px;
      height: 160px;
      min-height: 160px;
      text-align: center;
      border-radius: 10px;
      img {
        padding-top: 30px;
        width: 100px;
      }
    }
  }
  .pact-list-line {
    height: 15px;
    background: #ededed;
  }
}
.no-pact {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  img {
    margin-top: -200px;
    width: 200px;
  }
  div {
    padding-top: 40px;
    color: rgba(153, 153, 153, 1);
    font-size: 28px;
  }
}
</style>
